import { RichText } from "@/components/RichText";
import type { NativeCompare as Data } from "@/lib/types";

export default function Native({ data }: { data: Data }) {
  return (
    <section className="native" id="native">
      <div className="native-inner">
        <div className="section-header">
          <span className="section-eyebrow">{data.eyebrow}</span>
          <RichText as="h2" className="section-title" html={data.title} />
          <p className="section-sub">{data.sub}</p>
        </div>
        <div className="native-compare">
          <div className="native-col">
            <div className="native-col-label">{data.legacy.label}</div>
            <h3 className="native-title">{data.legacy.title}</h3>
            <ul className="native-points">
              {data.legacy.points.map((p) => (
                <li className="native-point" key={p}>
                  {p}
                </li>
              ))}
            </ul>
          </div>
          <div className="native-col highlight">
            <div className="native-col-label">{data.steer.label}</div>
            <h3 className="native-title">{data.steer.title}</h3>
            <ul className="native-points">
              {data.steer.points.map((p) => (
                <li className="native-point" key={p}>
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
